import {
    FromDomainStatus,
    type GetSharedInboxConfig_sharedInboxConfig_sharedAddresses_fromDomain as FromDomainConfig,
} from 'nutshell-graphql-types';

import {VerificationState} from './consts';

export interface DnsRecord {
    label: string;
    fullName: string;
    status: FromDomainStatus;
}

export function getDnsRecords(fromDomain: FromDomainConfig): DnsRecord[] {
    return [
        {
            label: 'DKIM',
            fullName: 'DomainKeys Identified Mail',
            status: fromDomain.nutshellDkimStatus,
        },
        {
            label: 'SPF',
            fullName: 'Sender Policy Framework',
            status: fromDomain.nutshellMailfromStatus,
        },
        {
            label: 'DMARC',
            fullName: 'Domain-based Message Authentication',
            status: fromDomain.refreshedDmarcStatus,
        },
    ];
}

export function getIsReplyingVerified(fromDomain: FromDomainConfig | null | undefined): boolean {
    if (!fromDomain) {
        return false;
    }

    return (
        fromDomain.nutshellDkimStatus === FromDomainStatus.STATUS_VERIFIED &&
        fromDomain.refreshedDmarcStatus === FromDomainStatus.STATUS_VERIFIED
    );
}

export function getButtonLabel(verificationState: VerificationState, isSending: boolean): string {
    if (isSending) {
        return 'Sending…';
    }

    switch (verificationState) {
        case VerificationState.VERIFYING:
            return 'Verifying…';
        case VerificationState.FAILED:
            return 'Retry test email';
        default:
            return 'Send test email';
    }
}

export function getVerificationStatus(isVerified: boolean, verificationState: VerificationState) {
    if (verificationState === VerificationState.VERIFYING) {
        return VerificationState.VERIFYING;
    }
    if (verificationState === VerificationState.FAILED) {
        return VerificationState.FAILED;
    }
    if (isVerified || verificationState === VerificationState.VERIFIED) {
        return VerificationState.VERIFIED;
    }

    return VerificationState.IDLE;
}
